import { Grid, GridItem } from "@certn/cascadia-react";
import { BrandProvider } from "@certn/cascadia-react/context/BrandProvider";
import { useEffect, useState } from "react";
import { ColorPreview } from "./ColorPreview";
import { PrimaryColorForm } from "./PrimaryColorForm";
import { useFetchCobranding } from "./hooks/useFetchCobranding";

export function ColorCustomization() {
  const { primaryColor } = useFetchCobranding();
  const [previewColor, setPreviewColor] = useState(primaryColor || "");
  const handleColorChange = (color: string) => setPreviewColor(color);

  useEffect(() => {
    if (primaryColor) {
      setPreviewColor(primaryColor);
    }
  }, [primaryColor]);

  return (
    <Grid>
      <GridItem span={[12, 12, 12, 12, 6]}>
        <PrimaryColorForm onColorChange={handleColorChange} />
      </GridItem>
      <GridItem span={[12, 12, 12, 12, 6]}>
        <BrandProvider primaryColor={previewColor} global={false}>
          <ColorPreview />
        </BrandProvider>
      </GridItem>
    </Grid>
  );
}
